import { useEstimationsForm } from './Dialog.h'
import {
    useTheme,
    useMediaQuery
} from '@mui/material'

import MotionDialog from '@shared/components/MotionDialog'
import Fields from './fields/Fields'
import Cropper from './Cropper'
import Docs from './documents/Docs'
import { FormProvider } from 'react-hook-form'
import 'cropperjs/dist/cropper.css'

export default function EstimationForm({instance}) {
    const context = useEstimationsForm(instance)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <FormProvider {...context.form}>
            <MotionDialog
                onClose={context.handleClose}
                slotProps={{
                    paper: {
                        component: 'form',
                        onSubmit: context.handleSave,
                        sx: {height: '100%'}
                    }
                }}
                context={context}
                fullScreen={isMobile}
            >
                <Fields />
                {context.dialogMode == 'cropper' && <Cropper />}
                {context.dialogMode == 'docs' && <Docs />}
            </MotionDialog>
        </FormProvider>
    )
}